$(document).foundation();

$(function() {
    if (Foundation.MediaQuery.current == 'small') {
        var threshold = $('.breadcrumb-wrap').length ? 50 : 100;
    } else {
        var threshold = $('.breadcrumb-wrap').length ? 80 : 130;
    }
    if ($(document).scrollTop() > threshold) {
        $('#header').addClass('solid');
    }

    $(window).scroll(function() {
        if (Foundation.MediaQuery.current == 'small') {
            var scrollThreshold = $('.breadcrumb-wrap').length ? 50 : 100;
        } else {
            var scrollThreshold = $('.breadcrumb-wrap').length ? 80 : 130;
        }
        if ($(document).scrollTop() > scrollThreshold) {
            $('#header').addClass('solid');
        }
        else {
            $('#header').removeClass('solid');
        }
    });

    $(document).on('click', '.icon-menu', function() {
        $('#header').toggleClass('menu-open');
        $('body').toggleClass('menu-open');
    });

    $('.tile-slider').each(function() {
        var grid = $(this);
        var prevArrow = grid.parent().find('.tile-prev-slide');
        var nextArrow = grid.parent().find('.tile-next-slide');
        grid.slick({
            infinite: true,
            slidesToShow: 2.85,
            slidesToScroll: 1,
            centerMode: true,
            arrows:true,
            dots:false,
            prevArrow:prevArrow,
            nextArrow:nextArrow,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 1.75,
                    slidesToScroll: 1,
                  }
              },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    });

    $('.link-toggle').on('click', function() {
        $(this).parents('.l1-item').toggleClass('open');
        return false;
    });

    $(".elements__herocarousel").each((_index, element) => {
    	let direction = "right";

    	const self = $(element);
    	const imageCarousel = self.find(".image-carousel");
    	const mainCarousel = self.find(".text-carousel").slick({
    		fade: true,
    		arrows: false,
    		dots: false,
    		swipe: false
    	});

    	// self.find(".nav-buttons").on("click", ".prev, .next", event => {
    	// 	if ($(event.currentTarget).hasClass("next")) mainCarousel.next();
    	// 	else mainCarousel.prev();
    	// });
    	// self.on("click", ".nav-buttons .prev", () => {
    	// 	mainCarousel.prev();
    	// });

    	self.on("click", ".nav-buttons .next, .nav-buttons .prev", event => {
    		const isNext = $(event.currentTarget).hasClass("next");
    		direction = isNext ? "right" : "left";
    		mainCarousel.slick(isNext ? "slickNext" : "slickPrev");
    	});

    	mainCarousel.on("beforeChange", (_event, _slick, _currentSlide, nextSlide) => {
    		const previous = imageCarousel.find(".current").removeClass("current").addClass("prev");
            const current = imageCarousel.find(`[data-index=${nextSlide + 1}]`).addClass("current").removeClass("left").removeClass("right").removeClass("none").addClass(direction);

            current.find("video").each((_index, element) => {
                if (element instanceof HTMLVideoElement) {
                    if (element.hasAttribute("paused-time")) {
                        element.currentTime = parseInt(element.getAttribute("paused-time"));
                    }
                }
            });

    		setTimeout(() => {
                imageCarousel.find(".prev").removeClass("prev");

                previous.find("video").each((_index, element) => {
                    if (element instanceof HTMLVideoElement) {
                        element.setAttribute("paused-time", element.currentTime);
                    }
                });
            }, 500);

    		const index = self.find(".position .current");
    		index.attr("prev-text", index.attr("text"));
    		index.attr("text", ("0" + imageCarousel.find(".current").data("index")).slice(-2));
    		index.addClass("animate");

    		setTimeout(() => index.removeClass("animate"), 200);
    	});
    });

    $('#contact-form').submit(function() {
        var submitMessage = $(this).parent().find('.submit-message');

        $(this).ajaxSubmit({
            success: function(){
                $('#contact-form').addClass('hide');
                submitMessage.removeClass('hide');
            }
        });

        return false;
    });

    $(".elements__largecarouselelement").each((_index, element) => {
        const carousel = $(element).find(".carousel-container");

        carousel.slick({
            arrows: true,
            dots: true
        });
    });

    // Camp Schedule
    $('.camp-schedule-slider').each(function() {
        var slider = $(this);
        var prevArrow = slider.parent().find('.schedule-prev-slide');
        var nextArrow = slider.parent().find('.schedule-next-slide');
        slider.slick({
            infinite: false,
            slidesToShow: 3.5,
            slidesToScroll: 1,
            centerMode: false,
            arrows:true,
            dots:false,
            prevArrow:prevArrow,
            nextArrow:nextArrow,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                  }
              },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                  }
                }
            ]
        });
    });

    $(".sub-nav-wrap.nav-vertical").on("click", ".link.active", event => {
        event.preventDefault();
        event.stopPropagation();

        $(".sub-nav-wrap.nav-vertical").toggleClass("open");
        
        return false;
    });
});
